// PrivateShowCircleProgressBar.js
import { connect } from 'react-redux';

import PrivateShowCircleProgressBar from '../component/PrivateShowCircleProgressBar.jsx';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getGoalData from '../selector/getGoalData.js';
import getPrivateShowStatus from '../selector/getPrivateShowStatus.js';

const mapStateToProps = (state, { streamId }) => {
  const status = getPrivateShowStatus(state, streamId);
  const fundingId =
    getLiveStreamData(state, [streamId, 'privateShow'], 'fundingId') || 'mock';
  const target = getGoalData(state, [fundingId, 'levels', 0], 'target');
  const progress = getGoalData(state, [fundingId], 'progress');

  return {
    status,
    target,
    progress,
  };
};

export default connect(mapStateToProps, null)(PrivateShowCircleProgressBar);
